import React, { useState } from "react";

/**
 * A tiny data-URI SVG placeholder for product/media images that fail to load.
 * Keeps the layout stable instead of showing a browser's broken-image icon.
 */
export const FALLBACK_IMAGE =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'>
  <rect width='100%' height='100%' fill='#1C1C1C'/>
  <g stroke='#FFC107' stroke-width='1.4' fill='none' opacity='0.6'>
    <circle cx='200' cy='170' r='46'/>
    <path d='M80 300 L160 220 L220 280 L320 180 L360 220'/>
  </g>
  <text x='200' y='340' text-anchor='middle' font-family='monospace' font-size='18' fill='#A1A1AA' letter-spacing='4'>FMAA</text>
</svg>`.trim());

/**
 * SafeImage — <img> with a baked-in onError fallback.
 * Use it anywhere product / post / drop images render on public pages.
 */
export const SafeImage = ({ src, alt, className, loading = "lazy", ...rest }) => {
  const [current, setCurrent] = useState(src || FALLBACK_IMAGE);
  return (
    <img
      src={current}
      alt={alt}
      loading={loading}
      className={className}
      onError={() => {
        if (current !== FALLBACK_IMAGE) setCurrent(FALLBACK_IMAGE);
      }}
      {...rest}
    />
  );
};
